var request = require('../../js/request.js')
// 192.168.10.99

// 办公寄存柜相关API
var officeLockerApi = {
	// 获取设备信息
	getDeviceInfo: function () {
		return request.post('/getDeviceInfo')
	},
	// 启动登录（启动刷卡和验证指纹程序）
	startLogin: function (data) {
		return request.post('/startLogin', data)
	},
	// 账号登录（专柜专用）
	accountLogin: function (data) {
		return request.post('/accountLogin', data)
	},
	// 轮询-存取物校验登录身份（专柜专用）
	checkLoginNotRandom: function () {
		return request.post('/checkLoginNotRandom')
	},
	// 轮询-存物校验登录身份（随机箱格）
	checkLoginRandomSave: function () {
		return request.post('/checkLoginRandomSave')
	},
	// 轮询-取物校验登录身份（随机箱格）
	checkLoginRandomFetch: function () {
		return request.post('/checkLoginRandomFetch')
	},
	// 随机箱格，再存一个
	randomSaveAnother: function (data) {
		return request.post('/randomSaveAnother', data)
	},
	// 开门
	openBox: function (data) {
		return request.post('/openBox', data)
	}
}


export {
	officeLockerApi
}



//////////////////
// WEBPACK FOOTER
// ./static/officeLocker/js/api.js
// module id = null
// module chunks = 